import React, { useEffect, useState } from 'react'
import { Button } from '../../../components/button'
import { useDispatch, useSelector } from 'react-redux'
import { getPaymentProcessors, deletePaymentProcessor } from '../../../slices/paymentprocessors'
import { Link, useNavigate } from "react-router-dom";
import { SvgRecycleBin } from '../../../components/svg';
import useModal from "../../../hooks/modal";
import Modal from '../../../components/modal';

const translations = [
    gettext('Payment Processors'),
    gettext('Add a payment processor'),
    gettext('Name'),
    gettext('Type'),
    gettext("You cannot delete a payment processor with active plans"),
    gettext('Confirm'),
    gettext('Are you sure you want to delete this payment processor?'),
]

const PaymentProcessors = () => {

    const dispatch = useDispatch()
    const paymentProcessors = useSelector((state) => state.paymentprocessors.results)
    const navigate = useNavigate()
    const [isShowingDelete, toggleDelete] = useModal();
    const [paymentProcessorToDelete, setPaymentProcessorToDelete] = useState(null);

    useEffect(() => {
        dispatch(getPaymentProcessors())
    }, [])

    const showDeleteConfirm = (e, paymentProcessor) => {
        e.stopPropagation()
        toggleDelete()
        setPaymentProcessorToDelete(paymentProcessor.id)
    }
        
    const confirmDelete = () => {
        dispatch(deletePaymentProcessor(paymentProcessorToDelete)).then(() => {
            dispatch(getPaymentProcessors())
            toggleDelete()
        })   
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header flex-wrap">
                        <h1 className="title">{gettext('Payment Processors')}</h1>
                        <Link to={"new"}><Button variant={"secondary"} size={"sm"}>{gettext('Add a payment processor')}</Button></Link>
                    </div>
                </div>
            </div>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4 overflow-scroll">
                            <table className="table table-hover component-table">
                                <thead className="bold">
                                    <tr>
                                        <th>{gettext('Name')}</th>
                                        <th>{gettext('Type')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paymentProcessors.map((paymentProcessor) =>
                                        <tr key={paymentProcessor.id} onClick={() => navigate(`${paymentProcessor.id}/`)}>
                                            <th>{paymentProcessor.name}</th>
                                            <td>{paymentProcessor.payment_processor_display}</td>
                                            { paymentProcessor.has_plans ? 
                                                <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                    <span className="delete-disabled tooltip">
                                                        <SvgRecycleBin />
                                                        <span className="tooltiptext">{gettext("You cannot delete a payment processor with active plans")}</span>
                                                    </span>
                                                </td>
                                                :
                                                <td className="text-center" onClick={(e) => showDeleteConfirm(e, paymentProcessor)}><SvgRecycleBin /></td>
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Modal
                        show={isShowingDelete}
                        onClose={toggleDelete}
                        icon={<SvgRecycleBin />}
                        onClick={confirmDelete}
                        confirmButtonText={gettext('Confirm')}
                    >
                        <p><strong>{gettext('Are you sure you want to delete this payment processor?')}</strong></p>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default PaymentProcessors